/*
    Mini Cart methods, functionality and data vars
*/

export default function miniCart() {
    return {
        data: {
            isMinicartOpen: false
        },

        watch: {
            isMinicartOpen(value) {
                if (this.isMobile) {
                    if (value) {
                        document.querySelector('body').classList.add('no-scroll');
                    } else {
                        document.querySelector('body').classList.remove('no-scroll');
                    }
                }
            }
        },

        methods: {
            /////////////////////////////////////////////
            // Mini cart
            toggleMinicart() {
                this.isMinicartOpen = !this.isMinicartOpen;
                this.isSearchOpen = false;
                this.isMenuOpen = false;
                this.closeAllMegamenus();
            },
        }
    }
}